// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__3U6ep","setting":"Settings_setting__2ZPuY","button":"Settings_button__AuQXk"};